import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../services/alert.service';
import {EnvService} from '../services/env.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-storage-tier-detail',
  templateUrl: './cmdb-storage-tier-detail.component.html'
})
export class CmdbStorageTierDetailComponent implements OnInit {
  @Input() cmdbStorageTierId: any;
  @Output() persisted = new EventEmitter<any>();
  cmdbStorageTier: any;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient, private route: ActivatedRoute,
              private router: Router, private alertService: AlertService) {
  }

  ngOnInit(): void {
    if (this.cmdbStorageTierId) {
      this.load(this.cmdbStorageTierId);

    } else {
      this.route.params.subscribe((params: Params) => {
        params['id'] === '0' ? this.createNew() : this.load(params['id']);
      });
    }
  }

  load(id: string): void {
    this.http.get(`${this.env.e.url}/domain/CmdbStorageTiers/${id}`).subscribe(data => {
      this.cmdbStorageTier = data;
    });
  }

  createNew(): void {
    this.cmdbStorageTier = { name: '', description: '', active: 'N', companyId: this.auth.getCompanyId() };
  }

  save(): void {
    const isUpdate = !!this.cmdbStorageTier.id;
    const request = isUpdate
      ? this.http.put(`${this.env.e.url}/domain/CmdbStorageTiers/${this.cmdbStorageTier.id}`, this.cmdbStorageTier)
      : this.http.post(`${this.env.e.url}/domain/CmdbStorageTiers`, this.cmdbStorageTier);
    request.subscribe(data => {
      this.cmdbStorageTier = data;
      this.alertService.info(`${isUpdate ? 'Updated' : 'Created'} ${this.cmdbStorageTier.name}`);
      this.persisted.emit({data, action: isUpdate ? 'updated' : 'added'});
    });
  }

  delete(): void {
    this.http.delete(`${this.env.e.url}/domain/CmdbStorageTiers/${this.cmdbStorageTier.id}`).subscribe(() => {
      this.persisted.emit({data: this.cmdbStorageTier, action: 'deleted'});
      this.alertService.info(`Deleted ${this.cmdbStorageTier.name}`);
      if (!this.cmdbStorageTierId) { this.router.navigate(['/storageTiers']); }
    });
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.cmdbStorageTier.active = target.checked ? 'Y' : 'N';
  }
}
